import { Injectable, NgZone } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Subject } from 'rxjs';

import { initializeApp } from 'firebase/app';

import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class NotificationService {
  private app = initializeApp(environment.firebaseConfig);

  private messaging = getMessaging(this.app);
  private notificationSubject = new Subject<any>();
  private audioContext: AudioContext | null = null;
  newNotification$ = this.notificationSubject.asObservable();
  private audio = new Audio('assets/sounds/notification.mp3');

  constructor(
    private toastr: ToastrService,
    private ngZone: NgZone,
  ) { }

  async requestPermission() {
    try {
      const permission = await Notification.requestPermission();

      if (permission !== 'granted') {
        console.log('Permission denied');
        return;
      }

      await this.registerFcm();
    } catch (err) {
      console.error(err);
    }
  }

  async registerFcm() {
    try {
      const registration = await navigator.serviceWorker.register(
        '/firebase-messaging-sw.js',
      );

      const token = await getToken(this.messaging, {
        vapidKey: environment.firebaseConfig.vapidKey,
        serviceWorkerRegistration: registration,
      });

      console.log('FCM Token:', token);

      return token;
    } catch (err) {
      console.error('FCM Error:', err);
      return '';
    }
  }

  listen() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.addEventListener('message', (event) => {
        if (event.data?.type === 'firebase-background-message') {
          this.ngZone.run(() => {
            this.handleIncomingNotification(event.data.payload, false);
          });
        }
      });
    }

    onMessage(this.messaging, (payload: any) => {
      this.ngZone.run(() => {
        this.handleIncomingNotification(payload, true);
      });
    });
  }

  private handleIncomingNotification(payload: any, showToast: boolean): void {
    this.notificationSubject.next(payload);
    this.playNotificationSound();

    if (!showToast) {
      return;
    }

    const title = payload?.notification?.title || 'Notification';

    const body = payload?.notification?.body || '';

    this.toastr.info(body, title, {
      timeOut: 5000,
      progressBar: true,
      closeButton: true,
    });
  }

  private playNotificationSound(): void {
    this.audio.currentTime = 0;
    this.audio.play().catch(err => {
      console.warn('Notification sound could not play:', err);
    });
  }
}
